import React, {useEffect} from 'react'
import './Pr_Tkinter.css'
import Intro_Image from "./Img/Intro-image.png"

const Pr_Tkinter = () => {
    const url = "https://raw.githubusercontent.com/MattiaBracco05/WidgetTkinter/main/widget.json"
    
    useEffect(() => {
        let title = document.getElementsByTagName('title')[0]
        title.innerHTML = "Progetto 4C | Tkinter"
        window.scrollTo(0,0)
    }, [])
    
    const carica_widgets =()=>{
        let riferimento = document.querySelector(".box-widgets")
        let ricerca = document.querySelector(".barra_filtro").value
        let insert = ""

        fetch(url)
        .then(testo => testo.json())
        .then((data)=>{
            data.map((elem, i)=>{
                if (ricerca === "" || ricerca === " "){
                    insert +=`<div class="card-widgets col-xl-3 col-lg-3 col-md-6 col-sm-6 col-10 mt-5">`
                    insert +=`<div class="header">`
                    insert +=`<div class="img-box">`
                    insert +=`<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">`
                    insert +=`<path d="M0 0h24v24H0z" fill="none"></path>`
                    insert +=`<path fill="rgba(66,193,110,1)" d="M20.083 15.2l1.202.721a.5.5 0 0 1 0 .858l-8.77 5.262a1 1 0 0 1-1.03 0l-8.77-5.262a.5.5 0 0 1 0-.858l1.202-.721L12 20.05l8.083-4.85zm0-4.7l1.202.721a.5.5 0 0 1 0 .858L12 17.65l-9.285-5.571a.5.5 0 0 1 0-.858l1.202-.721L12 15.35l8.083-4.85zm-7.569-9.191l8.771 5.262a.5.5 0 0 1 0 .858L12 13 2.715 7.429a.5.5 0 0 1 0-.858l8.77-5.262a1 1 0 0 1 1.03 0zM12 3.332L5.887 7 12 10.668 18.113 7 12 3.332z"></path>`
                    insert +=`</svg>`
                    insert +=`</div>`
                    insert +=`<h1 class="title">${elem.parte[0].titolo}</h1>`
                    insert +=`</div>`
                    insert +=`<div class="content">`
                    insert +=`<p>Guida sviluppata da ${elem.nome}</p>`
                    insert +=`<a class='btn-link' style='text-decoration:none; color:#1d8122' href='/Progetti/Tkinter/Guida' data-nome="${elem.parte[0].titolo}"> Scopri di più </a>`
                    insert +=`</div>`
                    insert +=`</div>`
                } else {
                    for(let x = 0; x < elem.keyword.length; x++){
                        if(ricerca.toLowerCase() === elem.keyword[x].toLowerCase()){
                            insert +=`<div class="card-widgets col-xl-3 col-lg-3 col-md-6 col-sm-6 col-10 mt-5">`
                            insert +=`<div class="header">`
                            insert +=`<div class="img-box">`
                            insert +=`<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">`
                            insert +=`<path d="M0 0h24v24H0z" fill="none"></path>`
                            insert +=`<path fill="rgba(66,193,110,1)" d="M20.083 15.2l1.202.721a.5.5 0 0 1 0 .858l-8.77 5.262a1 1 0 0 1-1.03 0l-8.77-5.262a.5.5 0 0 1 0-.858l1.202-.721L12 20.05l8.083-4.85zm0-4.7l1.202.721a.5.5 0 0 1 0 .858L12 17.65l-9.285-5.571a.5.5 0 0 1 0-.858l1.202-.721L12 15.35l8.083-4.85zm-7.569-9.191l8.771 5.262a.5.5 0 0 1 0 .858L12 13 2.715 7.429a.5.5 0 0 1 0-.858l8.77-5.262a1 1 0 0 1 1.03 0zM12 3.332L5.887 7 12 10.668 18.113 7 12 3.332z"></path>`
                            insert +=`</svg>`
                            insert +=`</div>`
                            insert +=`<h1 class="title">${elem.parte[0].titolo}</h1>`
                            insert +=`</div>`
                            insert +=`<div class="content">`
                            insert +=`<p>Guida sviluppata da ${elem.nome}</p>`
                            insert +=`<a class='btn-link' style='text-decoration:none; color:#1d8122' href='/Progetti/Tkinter/Guida' data-nome="${elem.parte[0].titolo}"> Scopri di più </a>`
                            insert +=`</div>`
                            insert +=`</div>`
                        }
                    }
                }
            })

            riferimento.innerHTML = insert

            const linkElements = document.querySelectorAll('.btn-link')
            linkElements.forEach((link) => {
                link.addEventListener('click', () => {
                    const nome = link.dataset.nome;
                    localStorage.setItem('nome', nome);
                })
            })

        })

    }

    useEffect(() => {
        carica_widgets()
    }, [])
    

  return (
    <div>
        {/* === sotto nav bar === */}

        <div className='row under-nav d-flex justify-content-center align-items-center mt-5'>
            <div className="col-xl-4 col-lg-4 col-md-7 col-sm-10 col-11 d-flex justify-content-center align-items-center order-lg-1 order-xl-1 order-2 pt-lg-0 pt-xl-0 pt-4" data-aos="fade-up" data-aos-delay="400">
                <div>
                    <h1 className='sub-under-nav'>| Progetti Tkinter<br/> Benvenuto nei progetti della 4C sul modulo Tkinter di python</h1>
                    <p className='txt-under-nav mt-3'>
                        In questa pagina troverai tutti i lavori fatti da questi studenti di questa classe!
                    </p>

                    <div className='d-flex justify-content-lg-start justify-content-xl-start justify-content-md-center justify-content-sm-center justify-content-center mb-3'>

                        <div className="group col-12">
                            <svg className="icon-src" aria-hidden="true" viewBox="0 0 24 24"><g><path d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"></path></g></svg>
                            <input placeholder="Search" type="search" className="input barra_filtro" onChange={carica_widgets}/>
                        </div>

                    </div>
                    
                </div>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-9 col-10 mt-5 d-flex justify-content-center order-1 order-lg-2 order-xl-2 mt-5" data-aos="zoom-in" data-aos-delay="400">
                <img src={Intro_Image} alt="" className='img-fluid flaoting res-intro-image'/>
            </div>
        </div>

        <svg width="100%" height="100%" id="svg" viewBox="0 0 1440 310" xmlns="http://www.w3.org/2000/svg" className="mw transition duration-300 ease-in-out delay-150">
            <path d="M 0,400 C 0,400 0,200 0,200 C 198.13333333333333,154.66666666666669 396.26666666666665,109.33333333333334 529,128 C 661.7333333333333,146.66666666666666 729.0666666666667,229.33333333333331 870,252 C 1010.9333333333333,274.6666666666667 1225.4666666666667,237.33333333333334 1440,200 C 1440,200 1440,400 1440,400 Z" stroke="none" strokeWidth="0" fill="#0104a3" fillOpacity="1" className="transition-all duration-300 ease-in-out delay-150 path-0" transform="rotate(-180 720 200)"></path>
        </svg>
        
        {/* === sotto nav bar === */}


        {/* widgets disponibili */}
        <div className="row justify-content-center aling-items-center box-widgets">

        </div>
        {/* widgets disponibili */}


    </div>
  )
}

export default Pr_Tkinter